import { authenticatedRequest } from "@/hooks/api";
import { ProspectType, TourType } from "@/types";
import { normalizeProspect } from "@/utils/prospect/normalize-prospect";

import { normalizeTour } from "./normalize-tour";

export function fetchTourAndProspect({
  tourToken,
  accessToken,
  latitude,
  longitude,
}: {
  tourToken: string;
  accessToken: string;
  latitude?: number;
  longitude?: number;
}): Promise<{
  prospect: ProspectType;
  tour: TourType;
}> {
  let query = "";
  if (latitude && longitude) {
    query = `?latitude=${latitude}&longitude=${longitude}`;
  }

  return authenticatedRequest({
    method: "GET",
    url: `/tour/${tourToken}${query}`,
    accessToken,
  })
    .then((response) => response.data)
    .then(({ tour: apiTour, config }) => {
      const prospect = normalizeProspect(apiTour.prospect);
      const tour = normalizeTour(apiTour, config);

      return { prospect, tour };
    });
}
